import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  userInfo: object | null;
}

const initialState: UserState = {
  userInfo: null,
};

export const CustomerAuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAdminAuthInfo: (state, action: PayloadAction<UserState>) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setAdminAuthInfo } = CustomerAuthSlice.actions;
export default CustomerAuthSlice.reducer;
